import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandCircleDown from "@mui/icons-material/ExpandCircleDown";
import { Grid } from "@mui/material";
import ResourceCollectionIIForm from "./ResourceCollectionIIForm";
import { ResourceCollectionIIFormObject } from "../../app/models/Answers";

export default function ScienceSensory(props:any) {
  const { onSave, answersData, onAnswerChange } = props;


  const ResourceCollectionIICodes: ResourceCollectionIIFormObject = {
    titleCode: 63,
    titleBilingualCode: 64,
    ageGroupCode: 65,
    ageGroupBiligualCode: 66,
    intendedGoalsCode: 67,
    intendedGoalsBiligualCode: 68,
    materialsCode: 69,
    materialsBiligualCode: 70,
    processCode: 71,
    processBiligualCode: 72,
    developmentCode: 73,
    developmentBiligualCode: 74
  };

  return (
    <Grid item xs={12} px={3} pt={3}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandCircleDown className="blue-expand-icon" />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body1" fontWeight="bold">
            RC II-1 Science/Sensory Learning Experience
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <ResourceCollectionIIForm onSave={onSave} answersData={answersData} onAnswerChange={onAnswerChange} ResourceCollectionIICodes={ResourceCollectionIICodes}/>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}

